import mixitup from 'mixitup';

const filter = document.querySelector('.counselor-filter');
const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

if (filter) {
    const filterTrigger = filter.querySelector('.counselor-filter__trigger');
    const filterClose = filter.querySelector('.counselor-filter__close');
    const filterItemsContainer = filter.querySelector('.counselor-filter__items-container');
    const filterItems = filterItemsContainer.querySelectorAll('button, a');

    if (filterTrigger && filterItemsContainer) {
        const updateFilterComponent = () => {
            if (isMobile() && filter.classList.contains('counselor-filter--closed')) {
                filterItemsContainer.style.height = '0';
                filterTrigger.setAttribute('aria-expanded', 'false');
                filterItemsContainer.setAttribute('aria-hidden', 'true');
                filterItems.forEach((item) => {
                    item.setAttribute('tabindex', '-1');
                });
            } else {
                filterItemsContainer.style.height = `${filterItemsContainer.scrollHeight}px`;
                filterTrigger.setAttribute('aria-expanded', 'true');
                filterItemsContainer.setAttribute('aria-hidden', 'false');
                filterItems.forEach((item) => {
                    item.setAttribute('tabindex', '0');
                });
            }
        };

        updateFilterComponent();

        [filterTrigger, filterClose].forEach((button) =>
            button.addEventListener('click', () => {
                if (isMobile()) {
                    filter.classList.toggle('counselor-filter--closed');

                    updateFilterComponent();
                }
            })
        );

        window.addEventListener('resize', () => {
            updateFilterComponent();
        });
    }

    const mixitupContainer = document.querySelector('.counselor-overview__content');

    if (mixitupContainer) {
        const resetBtn = document.querySelector('.counselor-filter__reset');

        var mixer = mixitup(mixitupContainer, {
            selectors: {
                target: '.counselor-teaser',
            },
            animation: {
                easing: 'ease-in-out',
            },
            controls: {
                toggleLogic: 'or',
            },
        });

        if (resetBtn) {
            resetBtn.addEventListener('click', () => {
                mixer.filter('all');
            });
        }
    }
}
